export function crmObjectEntriesList() {
  return {
    restrict: 'E',
    template: require('./crm-object-entries-list.directive.html'),
    scope: {
      companyId: '<',
      organizationId: '<',
      entries: '=',
      objectsDescriptions: '=',
      contactObjectName: '<',
      chooseChildObject: '<',
      chooseSearchType: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
}
